export const styles = {
  button: (bookingSnapshot) => {
    return {
      padding: '8px 12px',
      fontSize: '0.875rem',
      fontWeight: '500',
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      width: bookingSnapshot ? '150px' : '120px',
      borderRadius: '4px',
      minWidth: 'auto',
      color: (theme) =>
        bookingSnapshot
          ? theme.palette.violets.violet400
          : theme.palette.blues.primaryBlue500,
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: (theme) => theme.palette.blues.primaryBlue50,
        color: (theme) =>
          bookingSnapshot
            ? theme.palette.violets.violet600
            : theme.palette.blues.primaryBlue600,
      },
      '&:disabled': {
        color: (theme) => theme.palette.grays.gray400,
        backgroundColor: 'transparent',
        opacity: 0.5,
      },
      '&.MuiLoadingButton-loading': {
        color: 'transparent!important',
      },
      '& .MuiLoadingButton-loadingIndicator': {
        color: (theme) => theme.palette.blues.primaryBlue400,
      },
    };
  },
};
